import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/40e6f223-8919-4b68-89de-d1f57d193a6e";
export const REGISTER_URL = "https://a.ntrk2.com/2cb3dcc7-637f-45cb-adf3-a86c0b183b3c";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://vivagana.loadprkw2a.com/download?openExternalBrowser=1&id=1ttb2t58s165jw7";

export * from "./codes";
export * from "./context";
